export { helpCenterRoute, helpCenterRouteWithResource } from './routes';
